/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { CSSProperties, useState } from 'react';
import { Layout, theme } from 'antd';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Menu } from '@/components/menus';
import logo from '@/assets/images/logo-header.png';
import 'antd/dist/reset.css';

const { Content, Sider } = Layout;

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer }
  } = theme.useToken();

  return (
    <Layout hasSider>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        theme='light'
        style={sidebarStyle}
        width={280}
        collapsedWidth={80}
      >
        <div css={logoStyles}>
          <img src={logo} alt='logo' />
        </div>
        <Menu collapsed={collapsed} />
      </Sider>
      <Layout style={{ background: '#fff', height: '100%' }}>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content css={contentStyles(colorBgContainer, collapsed)}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

const logoStyles = css`
  height: var(--header-height);
  padding: 0.8rem;
  border-inline-end: 0.1rem solid var(--border-color);
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

const contentStyles = (background: string, collapsed: boolean) => css`
  background: ${background};
  margin-top: var(--header-height);
  margin-inline-start: ${collapsed
    ? 'var(--collapsed-sidebar-width)'
    : 'var(--expanded-sidebar-width)'};
  transition: margin-inline-start 0.25s ease;
  min-height: calc(100vh - var(--header-height));
`;

const sidebarStyle: CSSProperties = {
  overflow: 'auto',
  height: '100vh',
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: 'thin',
  scrollbarColor: 'unset'
};
